import * as React from "react";
import {
    UitkCardContentSection,
    UitkCardLink,
    UitkLayoutFlexItem,
    UitkCard,
    UitkIcon,
    UitkLayoutFlex,
    UitkPageLoader,
    UitkSpacing,
    UitkText,
    UitkList,
    UitkListItem
} from "@egencia/uitk-react";
import {useState} from "react";

function PanelArticlesListItem({ article, articleGroupType, icon, onClick }) {
    
    function handleClickArticle(e) {
        e.preventDefault();
        onClick && onClick();
        const omnitureTitle = article.defaultTitleForEmail.replace(/\?/g, '').split(' ').join('.');
        const searchOrDefaultPage = articleGroupType === 'Search' ? "Search" : "DefaultPage";
        const faqOrAlert = articleGroupType === 'Alert' ? 'Alert' : 'Faq';
        omnitureLog.logClickEvent(`HelpCenter.Panel.${searchOrDefaultPage}.${faqOrAlert}Content.Expand.` + omnitureTitle);
        window.location.href = `/help-center/panel/${EG.user ? '' : 'anonymous/'}${article.id}`;
    }
    
    return (
        <UitkCard className="panel-item" id={`panel-articles-list-${article.id}`}>
            <UitkCardContentSection padded border="bottom">
                <UitkLayoutFlex>
                    {icon && (
                        <UitkLayoutFlexItem alignSelf="center" grow={0}>
                            <UitkSpacing padding={{inlineend: "two"}}>
                                <UitkIcon name={icon} size="small"/>
                            </UitkSpacing>
                        </UitkLayoutFlexItem>
                    )}
                    <UitkLayoutFlexItem grow={1}>
                        <UitkText size={400}>
                            <div className={`panel-articles-list-item-title`} dangerouslySetInnerHTML={{ __html: article.title}}/>
                        </UitkText>
                    </UitkLayoutFlexItem>
                    <UitkLayoutFlexItem alignSelf="center" grow={0}>
                        <UitkIcon name="chevron_right" size="medium"/>
                    </UitkLayoutFlexItem>
                </UitkLayoutFlex>
            </UitkCardContentSection>
            <UitkCardLink>
                <a href="#" className={`panel-articles-list-item-link`} onClick={handleClickArticle}></a>
            </UitkCardLink>
        </UitkCard>
    );
}

export function PanelArticlesList({ articleGroups, className }) {
    const [loading, setLoading] = useState(false);
    
    return (
        <div className={className}>
            <UitkSpacing padding={{inline: "four"}}>
                    {articleGroups.map(({title, articles, icon, type}, i) => (
                        (articles && articles.length) ? (
                            <UitkSpacing padding={{blockend: 'four'}} key={i}>
                                <div id={"panel-articles-"+type}>
                                    <UitkSpacing margin={{blockstart:"four"}}>
                                        <UitkText weight="bold">{title}</UitkText> 
                                    </UitkSpacing>
                                    <UitkList bullet="no-bullet">
                                        {articles.map((article, o) => (
                                            <UitkListItem key={o} style={{margin:0}}>
                                                <PanelArticlesListItem article={article} icon={icon} articleGroupType={type} onClick={() => setLoading(true)} />
                                            </UitkListItem>
                                        ))}
                                    </UitkList>
                                </div>
                            </UitkSpacing>
                        ) : <></>
                    ))} 
            </UitkSpacing>
            <UitkPageLoader visible={loading} />
        </div>
    )
}

